import { Helmet } from "react-helmet-async";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

function absoluteUrl(src) {
  if (!src) return undefined;
  if (src.startsWith("http")) return src;
  if (src.startsWith("/")) return `${BACKEND}${src}`;
  return src;
}

/**
 * SEO meta tags helper. Supply at least { title, description }.
 * If image is provided, it gets used for OG + Twitter cards.
 */
export default function SEO({
  title,
  description,
  image,
  url,
  type = "website",
  siteName = "Studio/Saar",
  noindex = false,
}) {
  const fullTitle = title ? title : "Studio/Saar® — Design with intention, built with soul.";
  const desc = description || "Tauri Saar — independent designer & developer. Brand systems, editorial interfaces and quiet products.";
  const imgUrl = absoluteUrl(image) || `${typeof window !== "undefined" ? window.location.origin : ""}/og-default.svg`;
  const pageUrl = url || (typeof window !== "undefined" ? window.location.href : "");

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {pageUrl && <link rel="canonical" href={pageUrl} />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      {imgUrl && <meta property="og:image" content={imgUrl} />}
      {pageUrl && <meta property="og:url" content={pageUrl} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {imgUrl && <meta name="twitter:image" content={imgUrl} />}
    </Helmet>
  );
}
